import { Route } from '@angular/router';
import { TEILRECHT_ROUTES } from '@zero/bezugsrecht/domain';

export const TEILRECHT_WEB_ROUTES: Route[] = [
  {
    path: '',
    loadComponent: () => import('./teilrecht-page-web.component').then((m) => m.TeilrechtPageWebComponent),
  },
  {
    path: ':id',
    loadComponent: () => import('./teilrecht-page-web.component').then((m) => m.TeilrechtPageWebComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./components/home/teilrecht-home.component').then((m) => m.TeilrechtHomeComponent),
      },
      {
        path: TEILRECHT_ROUTES.SUMMARY,
        loadComponent: () => import('./components/summary/teilrecht-summary.component').then((m) => m.TeilrechtSummaryComponent),
      },
      {
        path: TEILRECHT_ROUTES.SUCCESS,
        loadComponent: () => import('./components/success/teilrecht-success.component').then((m) => m.TeilrechtSuccessComponent),
      },
    ],
  },
];
